// extracted by mini-css-extract-plugin
module.exports = {"base":"src-ModalContent-base-9d0ba1a7"};